module.exports = __webpack_public_path__ + "house-twilight-red.81c7521438aba65a7698.svg";


//////////////////
// WEBPACK FOOTER
// /vercel/workpath0/src/assets/img/house-twilight-red.svg
// module id = ../../../../../src/assets/img/house-twilight-red.svg
// module chunks = main